const SvgBlock = (props) => (
  <svg height="1em" viewBox="0 0 16 16" width="1em" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(-1 -1)">
      <path d="M0 0h18v18H0z" />
      <path
        d="M2.5 9h13M9 15.5v-13"
        stroke="currentColor"
        strokeLinecap="square"
      />
      <rect height={14} rx={1} stroke="currentColor" width={14} x={2} y={2} />
    </g>
  </svg>
)

export default SvgBlock
